import { setAfterLoginRedirectURL } from "../../api/localStorage";
import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface Props {
  isAuthenticated: boolean;
  component: JSX.Element;
}

export const ProtectedComponent = ({ isAuthenticated, component }: Props): React.ReactElement => {
  const location = useLocation();
  useEffect(() => {
    if (!isAuthenticated) {
      setAfterLoginRedirectURL(location.pathname + location.search);
    }
    // eslint-disable-next-line
  }, []);

  return isAuthenticated ? component : <Navigate to={"/login"} />;
};
